import { render, staticRenderFns } from "./square-button.vue?vue&type=template&id=72574db6&scoped=true&"
import script from "./square-button.vue?vue&type=script&lang=js&"
export * from "./square-button.vue?vue&type=script&lang=js&"
import style0 from "./square-button.vue?vue&type=style&index=0&id=72574db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72574db6",
  null
  
)

export default component.exports